// extracted by mini-css-extract-plugin
export default {"interview":"InterviewApp-module__interview__G3Ggt","content":"InterviewApp-module__content__Ig19U"};